// D&D 5e Spell Effects Library for VTT
// Each spell has: name, school, level, shape, size (in grid squares), color

export const SPELL_SCHOOLS = {
  abjuration: { color: "#3b82f6", label: "Abjuration" },
  conjuration: { color: "#a855f7", label: "Conjuration" },
  divination: { color: "#06b6d4", label: "Divination" },
  enchantment: { color: "#ec4899", label: "Enchantment" },
  evocation: { color: "#ef4444", label: "Evocation" },
  illusion: { color: "#8b5cf6", label: "Illusion" },
  necromancy: { color: "#22c55e", label: "Necromancy" },
  transmutation: { color: "#f59e0b", label: "Transmutation" },
};

// shape: "sphere", "cone", "line", "cube", "cylinder", "aura"
// size: radius in feet for sphere/cylinder/aura, length for line/cone, side for cube
export const SPELL_EFFECTS = [
  // Evocation
  { name: "Fireball", school: "evocation", level: 3, shape: "sphere", size: 20, desc: "20ft radius sphere of fire" },
  { name: "Lightning Bolt", school: "evocation", level: 3, shape: "line", size: 100, width: 5, desc: "100ft long, 5ft wide line" },
  { name: "Burning Hands", school: "evocation", level: 1, shape: "cone", size: 15, desc: "15ft cone of fire" },
  { name: "Cone of Cold", school: "evocation", level: 5, shape: "cone", size: 60, desc: "60ft cone of cold" },
  { name: "Thunderwave", school: "evocation", level: 1, shape: "cube", size: 15, desc: "15ft cube of thunder" },
  { name: "Shatter", school: "evocation", level: 2, shape: "sphere", size: 10, desc: "10ft radius sphere of sound" },
  { name: "Wall of Fire", school: "evocation", level: 4, shape: "line", size: 60, width: 1, desc: "60ft long, 1ft wide, 20ft high" },
  { name: "Meteor Swarm", school: "evocation", level: 9, shape: "sphere", size: 40, desc: "40ft radius sphere" },
  { name: "Ice Storm", school: "evocation", level: 4, shape: "cylinder", size: 20, desc: "20ft radius, 40ft high cylinder" },
  { name: "Sacred Flame", school: "evocation", level: 0, shape: "aura", size: 5, desc: "Single target radiance" },
  { name: "Eldritch Blast", school: "evocation", level: 0, shape: "line", size: 120, width: 1, desc: "120ft beam" },
  { name: "Fire Bolt", school: "evocation", level: 0, shape: "line", size: 120, width: 1, desc: "120ft bolt of fire" },
  { name: "Guiding Bolt", school: "evocation", level: 1, shape: "line", size: 120, width: 1, desc: "120ft bolt of light" },
  { name: "Moonbeam", school: "evocation", level: 2, shape: "cylinder", size: 5, desc: "5ft radius, 40ft high cylinder" },
  { name: "Call Lightning", school: "conjuration", level: 3, shape: "cylinder", size: 5, desc: "5ft radius bolt from storm" },
  { name: "Spirit Guardians", school: "conjuration", level: 3, shape: "aura", size: 15, desc: "15ft radius aura around caster" },

  // Conjuration
  { name: "Fog Cloud", school: "conjuration", level: 1, shape: "sphere", size: 20, desc: "20ft radius sphere of fog" },
  { name: "Stinking Cloud", school: "conjuration", level: 3, shape: "sphere", size: 20, desc: "20ft radius nauseating cloud" },
  { name: "Cloudkill", school: "conjuration", level: 5, shape: "sphere", size: 20, desc: "20ft radius poison cloud" },
  { name: "Grease", school: "conjuration", level: 1, shape: "cube", size: 10, desc: "10ft square slippery grease" },
  { name: "Web", school: "conjuration", level: 2, shape: "cube", size: 20, desc: "20ft cube of webs" },
  { name: "Entangle", school: "transmutation", level: 1, shape: "cube", size: 20, desc: "20ft square area of grasping weeds" },
  { name: "Sleet Storm", school: "conjuration", level: 3, shape: "cylinder", size: 20, desc: "20ft radius, 20ft high icy area" },
  { name: "Insect Plague", school: "conjuration", level: 5, shape: "sphere", size: 20, desc: "20ft radius swarm of insects" },

  // Abjuration
  { name: "Shield of Faith", school: "abjuration", level: 1, shape: "aura", size: 5, desc: "+2 AC aura on target" },
  { name: "Antimagic Field", school: "abjuration", level: 8, shape: "sphere", size: 10, desc: "10ft radius antimagic zone" },
  { name: "Globe of Invulnerability", school: "abjuration", level: 6, shape: "sphere", size: 10, desc: "10ft radius spell immunity" },

  // Enchantment
  { name: "Hypnotic Pattern", school: "illusion", level: 3, shape: "cube", size: 30, desc: "30ft cube of mesmerizing lights" },
  { name: "Sleep", school: "enchantment", level: 1, shape: "sphere", size: 20, desc: "20ft radius area of sleep" },
  { name: "Calm Emotions", school: "enchantment", level: 2, shape: "sphere", size: 20, desc: "20ft radius calming effect" },
  { name: "Fear", school: "illusion", level: 3, shape: "cone", size: 30, desc: "30ft cone of fear" },

  // Necromancy
  { name: "Circle of Death", school: "necromancy", level: 6, shape: "sphere", size: 60, desc: "60ft radius sphere of death" },
  { name: "Blight", school: "necromancy", level: 4, shape: "aura", size: 5, desc: "Single target necrotic" },
  { name: "Hunger of Hadar", school: "conjuration", level: 3, shape: "sphere", size: 20, desc: "20ft radius void sphere" },

  // Transmutation
  { name: "Spike Growth", school: "transmutation", level: 2, shape: "sphere", size: 20, desc: "20ft radius area of spikes" },
  { name: "Plant Growth", school: "transmutation", level: 3, shape: "sphere", size: 100, desc: "100ft radius overgrowth" },

  // Illusion
  { name: "Darkness", school: "evocation", level: 2, shape: "sphere", size: 15, desc: "15ft radius magical darkness" },
  { name: "Faerie Fire", school: "evocation", level: 1, shape: "cube", size: 20, desc: "20ft cube of revealing light" },
  { name: "Silence", school: "illusion", level: 2, shape: "sphere", size: 20, desc: "20ft radius of silence" },
  { name: "Major Image", school: "illusion", level: 3, shape: "cube", size: 20, desc: "20ft cube illusion" },
];

// Get SVG for a placed spell effect
export const getSpellSVG = ({ spell, x, y, rotation, gs }) => {
  const color = SPELL_SCHOOLS[spell.school]?.color || "#ef4444";
  const alpha = 0.2;
  const strokeAlpha = 0.7;
  const r = (spell.size / 5) * gs; // Convert feet to grid pixels (5ft per square)

  if (spell.shape === "sphere" || spell.shape === "cylinder" || spell.shape === "aura") {
    return { type: "circle", cx: x, cy: y, r, fill: `${color}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`, stroke: color, strokeOpacity: strokeAlpha };
  }
  if (spell.shape === "cone") {
    const angle = (rotation || 0) * Math.PI / 180;
    const spread = Math.PI / 6; // 30 degree half-angle
    const p1x = x + r * Math.cos(angle - spread);
    const p1y = y + r * Math.sin(angle - spread);
    const p2x = x + r * Math.cos(angle + spread);
    const p2y = y + r * Math.sin(angle + spread);
    return { type: "path", d: `M ${x} ${y} L ${p1x} ${p1y} A ${r} ${r} 0 0 1 ${p2x} ${p2y} Z`, fill: `${color}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`, stroke: color, strokeOpacity: strokeAlpha };
  }
  if (spell.shape === "line") {
    const angle = (rotation || 0) * Math.PI / 180;
    const w = ((spell.width || 5) / 5) * gs / 2;
    const endX = x + r * Math.cos(angle);
    const endY = y + r * Math.sin(angle);
    const perpX = Math.sin(angle) * w;
    const perpY = -Math.cos(angle) * w;
    return { type: "polygon", points: `${x + perpX},${y + perpY} ${endX + perpX},${endY + perpY} ${endX - perpX},${endY - perpY} ${x - perpX},${y - perpY}`, fill: `${color}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`, stroke: color, strokeOpacity: strokeAlpha };
  }
  if (spell.shape === "cube") {
    const half = r;
    return { type: "rect", x: x - half, y: y - half, width: half * 2, height: half * 2, fill: `${color}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`, stroke: color, strokeOpacity: strokeAlpha };
  }
  return null;
};
